import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './lacal/en.json';
import ru from './lacal/ru.json';
import uz from './lacal/uz.json';

const savedLang = localStorage.getItem('language') || 'uz';

export async function initI18n() {
  await i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      uz: { translation: uz },
      ru: { translation: ru },
    },
    lng: savedLang,
    fallbackLng: 'uz',
    interpolation: {
      escapeValue: false,
    },
  });

  return i18n;
}

export default i18n;
